<section class="data-model-display-titlebar">
  <div class="data-model-display-titlebar-left">
    <h3>{{projectModel?.name ?? 'Data model loading...'}}</h3>
    <p *ngIf="projectModel?.description">
      {{projectModel?.description}}
    </p>
  </div>
  <div class="data-model-display-titlebar-right">

    <button *ngIf="projectModel?.name"
            nz-button
            nzType="default"
            nzSize="small"
            nz-tooltip
            nzTooltipTitle="Configure Data Model Schema"
            class="navigate-to-edit-page-button"
            (click)="navigateToEditPage()">
      <i class="fa-regular fa-gear"></i>&nbsp;Configure Schema
    </button>
  </div>

</section>

<rappider-list-grid *ngIf="projectModel?.fields; else noValue"
                    [config]="DATA_FIELD_SIMPLE_DISPLAY_LIST_CONFIG"
                    [className]="animateTable ? 'animated-table': ''"
                    [data]="projectModel?.fields!"
                    (listActionClick)="onListActionClick($event)"
                    (columnActionClick)="onDeleteDataFieldClick($event)"
                    (listActionDropdownItemClick)="onDataFieldListActionDropdownItemClick($event)"
                    (orderChange)="onOrderChange($event)"
                    [enableRowPointer]="enableRowPointer"
                    (rowActionClick)="onRowActionClick($event)"></rappider-list-grid>

<ng-template #noValue>
  <div class="no-value">
    <nz-skeleton [nzActive]="true"
                 [nzParagraph]="false"></nz-skeleton>
  </div>
</ng-template>
